
export function ValueProposition() {
  const benefits = [
    {
      title: 'Set up fast',
      description: 'Get started with a simple onboarding flow and a setup built around your business goals.',
    },
    {
      title: 'Easy to use',
      description: 'Everything is designed for real business owners, not engineers. If you can use email, you can use Dino Nuggets.',
    },
    {
      title: 'Results you can see',
      description: 'Track calls, conversations, and conversions with clear reporting that shows what is working.',
    },
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <img
              src="/readdy-assets/value-prop-001.jpg"
              alt="Small Business Success"
              className="w-full h-auto rounded-2xl shadow-2xl"
            />
            <div className="absolute -bottom-6 -left-6 bg-primary text-white px-8 py-6 rounded-xl shadow-xl">
              <div className="text-4xl font-bold">20+</div>
              <div className="text-sm">Hours Saved Weekly</div>
            </div>
          </div>

          <div className="space-y-8">
            <div>
              <span className="text-primary text-xs font-bold tracking-widest uppercase bg-primary/10 px-4 py-2 rounded-full">
                WHY DINO NUGGETS
              </span>
            </div>

            <h2 className="font-display text-4xl lg:text-5xl font-bold text-secondary leading-tight">
              Your technology should help you grow, not slow you down
            </h2>

            <p className="text-xl text-gray-600 leading-relaxed">
              We built Dino Nuggets because small businesses deserve the same powerful tools as Fortune 500 companies—without the complexity, cost, or confusion.
            </p>

            <div className="space-y-6">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
                      <i className="ri-check-line text-primary text-xl"></i>
                    </div>
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg text-secondary mb-2">
                      {benefit.title}
                    </h4>
                    <p className="text-gray-600 leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="pt-4">
              <div className="bg-gray-50 rounded-xl p-6 border-l-4 border-primary">
                <p className="text-gray-700 italic">
                  "Dino Nuggets lets me focus on running my business instead of constantly answering calls and chasing messages."
                </p>
                <div className="mt-4 flex items-center gap-3">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-primary to-secondary flex items-center justify-center text-white font-bold">
                    MM
                  </div>
                  <div>
                    <div className="font-semibold text-secondary">Matt McClure</div>
                    <div className="text-sm text-gray-600">Owner, MM Outdoor Services</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
